<script setup lang="ts">
import { $t } from "@/locales";
import { ossUrl } from "@/constants/apiConfig";
import { useAuthStore } from "@/store/modules/auth";
const { systemInfo } = useAuthStore();
defineOptions({
  name: "GlobalLogo",
});

interface Props {
  /** Whether to show the title */
  showTitle?: boolean;
}

withDefaults(defineProps<Props>(), {
  showTitle: true,
});
</script>

<template>
  <RouterLink to="/" class="w-full flex-center nowrap-hidden">
    <!-- <NImage v-if="systemInfo.logo" width="180" :src="ossUrl + systemInfo.logo" preview-disabled /> -->
    <SvgIcon local-icon="gvs" class="text-180px" />
  </RouterLink>
</template>

<style scoped></style>
